import React from 'react'
import versusImage from "../../assets/svgs/versusImage.svg"
import { cardStyles as styles } from './UpcomingLiveGameBanner.tailwind'
import routeConstant from '../../lib/constants/routeConstant'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from '@mui/material'


const BannerCard = ({ data }) => {
  const navigate = useNavigate();

  const handleOnClick = (id) => {
    navigate(`${routeConstant.LIVE_GAME_PAGE}/${id}`);
  }

  return (
    <Tooltip title={data?.matchTitle} arrow>
      <div className={styles.card} onClick={() => handleOnClick(data?._id)}>
        <img src={data.homeTeamImage} alt={data.homeTeamName} className={styles.teamImage} />
        <img src={versusImage} alt="versus" className={styles.versusImage} />
        <img src={data.awayTeamImage} alt={data.awayTeamName} className={styles.teamImage} />
      </div>
    </Tooltip>
  )
}

export default BannerCard